(function () {
  var api = window.NCProductLedVideo || {};

  function isElementDisplayed(element) {
    return Boolean(element && element.getClientRects && element.getClientRects().length);
  }

  function sendYouTubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: command,
        args: []
      }),
      "*"
    );
  }

  function playMedia(media) {
    if (!isElementDisplayed(media)) return;

    var video = media.querySelector("[data-nc-product-led-video-native]");
    var iframe = media.querySelector("[data-nc-product-led-video-youtube]");

    if (video) {
      video.play().catch(function () {});
    }

    if (iframe) {
      sendYouTubeCommand(iframe, "mute");
      sendYouTubeCommand(iframe, "playVideo");
    }
  }

  function pauseMedia(media) {
    var video = media.querySelector("[data-nc-product-led-video-native]");
    var iframe = media.querySelector("[data-nc-product-led-video-youtube]");

    if (video) {
      video.pause();
    }

    if (iframe) {
      sendYouTubeCommand(iframe, "pauseVideo");
    }
  }

  function resetRoot(root) {
    if (!root) return;

    if (root.ncProductLedVideoObserver) {
      root.ncProductLedVideoObserver.disconnect();
    }

    root.querySelectorAll("[data-nc-product-led-video-media]").forEach(function (media) {
      pauseMedia(media);
      delete media.dataset.ncProductLedVideoInitialEntrySeen;
    });

    delete root.ncProductLedVideoObserver;
    delete root.dataset.ncProductLedVideoInitialized;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncProductLedVideoInitialized === "true") return;

    root.dataset.ncProductLedVideoInitialized = "true";

    if (root.getAttribute("data-autoplay-on-scroll") !== "true" || !("IntersectionObserver" in window)) {
      return;
    }

    var mediaItems = root.querySelectorAll("[data-nc-product-led-video-media]");

    if (!mediaItems.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var media = entry.target;
          var hasSeenInitialEntry = media.dataset.ncProductLedVideoInitialEntrySeen === "true";

          if (!hasSeenInitialEntry) {
            media.dataset.ncProductLedVideoInitialEntrySeen = "true";

            if (entry.isIntersecting) {
              return;
            }
          }

          if (entry.isIntersecting) {
            playMedia(media);
          } else {
            pauseMedia(media);
          }
        });
      },
      { threshold: [0, 0.35] }
    );

    mediaItems.forEach(function (media) {
      observer.observe(media);
    });

    root.ncProductLedVideoObserver = observer;
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-led-video]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-led-video]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-led-video]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-led-video]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCProductLedVideo = api;

  if (!window.__ncProductLedVideoEventsBound) {
    window.__ncProductLedVideoEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCProductLedVideo.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCProductLedVideo.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCProductLedVideo.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCProductLedVideo.initAll(document);
  }
})();
